import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpService, TmsWebBaseService } from 'tms-lib';
import { UploadDocument } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class StoredDocumentService extends TmsWebBaseService {
  constructor(protected httpService: HttpService) {
    super('StoredDocument', httpService);
  }

  listFiles(uploadDocument: UploadDocument): Observable<any> {
    return this.httpService.get(
      `${this.apiUrl}/ListFiles/${uploadDocument.folderName}/${uploadDocument.subFolderName}`,
    );
  }

  uploadFile(uploadDocument: UploadDocument, file: any): Observable<string> {
    return this.httpService
      .postForText(
        `${this.apiUrl}/UploadFile/${encodeURIComponent(uploadDocument.folderName)}/${btoa(
          unescape(encodeURIComponent(uploadDocument.subFolderName)),
        )}/${btoa(unescape(encodeURIComponent(uploadDocument.fileName)))}`,
        file,
      )
      .pipe(map((fileUrl: string) => decodeURIComponent(fileUrl)));
  }

  uploadImage(uploadDocument: UploadDocument, file: any): Observable<string> {
    return this.httpService
      .postForText(
        `${this.apiUrl}/UploadImage/${encodeURIComponent(uploadDocument.folderName)}/${btoa(
          unescape(encodeURIComponent(uploadDocument.subFolderName)),
        )}/${btoa(unescape(encodeURIComponent(uploadDocument.fileName)))}`,
        file,
      )
      .pipe(map((fileUrl: string) => decodeURIComponent(fileUrl)));
  }

  removeFile(fullPathName: string): Observable<any> {
    return this.httpService.delete(`${this.apiUrl}/${btoa(unescape(encodeURIComponent(fullPathName)))}`);
  }

  openPreview(fullPath: string) {
    window.open(fullPath);
  }
}
